export const POSITIONS_TAB = "Positions";
export const ORDERS_TAB = "Orders";
export const TRADES_TAB = "Trades";
export const CLOSED_POSITIONS_TAB = "ClosedPositions";

export const PENDING_POSITION_VALID_DURATION = 600 * 1000;
export const UPDATED_POSITION_VALID_DURATION = 60 * 1000;
